import { Directive, ElementRef, Input, OnInit } from '@angular/core';

export enum TableConfigType {
  DEFAULT = 'DEFAULT',
  SELECT = 'SELECT',
}

@Directive({
    selector: '[appTableConfig]',
    standalone: true
})
export class TableConfigDirective implements OnInit {

  readonly CSS_WITH_SELECT = 'with-select';

  @Input() appTableConfig = TableConfigType.DEFAULT;

  constructor(private ref: ElementRef) { }

  ngOnInit(): void {
    if (this.appTableConfig === TableConfigType.SELECT) {
      const table = (this.ref.nativeElement as HTMLElement);
      table.classList.add(this.CSS_WITH_SELECT);
    }
  }

}
